import styled from 'styled-components'

export const DropdownFooterWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    > div {
        display: flex;
        width: calc(100% - 5px);
        &:nth-child(2) {
            margin-left: 10px;
        }
    }
    button {
        &:nth-child(2) {
            margin-left: 10px;
        }
    }
`
